import { DealSheet } from 'dsilo-ui-components';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getContractDataById, getDataModelById, getModelData } from '../../store/actions';
import { Loader } from "../loader";

const DealSheetComponent = (props) => {
	return (
		<div>
			<DealSheet {...props} />
		</div>
	)
}

const mapDispatchToProps = {
    getContractDataById,
    getDataModelById,
	getModelData,
};

const mapStateToProps = state => {
	return {
	  formData: state.form,	
	  user: state.user,
	};
  };
  
  export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DealSheetComponent));
  